module.exports = __webpack_public_path__ + "static/media/addrules.e5c20177.svg";